// To be copied from user-service incrementally until we have a better solution!
// https://github.com/stampedeapp/user-service/blob/master/src/types/graphql.d.ts

export type Maybe<T> = T;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = {
  [X in Exclude<keyof T, K>]?: T[X];
} &
  { [P in K]-?: NonNullable<T[P]> };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type. Pass in as a DateObject.getTime(). */
  Date: any;
  /** JavaScript Date object as an ISO timestamp */
  ISODate: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type User = {
  __typename?: 'User';
  /** The id of the user */
  id?: Maybe<Scalars['ID']>;
  /** The primary identity id of the user - this is an Auth0 concept */
  primaryIdentityId?: Maybe<Scalars['ID']>;
  /** The identity ids of the user - this is an Auth0 concept */
  identityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The given name of the user */
  givenName?: Maybe<Scalars['String']>;
  /** The family name of the user */
  familyName?: Maybe<Scalars['String']>;
  /** The client-facing name of the user */
  displayName?: Maybe<Scalars['String']>;
  /** The email address of the user */
  emailAddress?: Maybe<Scalars['String']>;
  /** The url of the picture of the user */
  pictureUrl?: Maybe<Scalars['String']>;
  /** The date-time that the account was created */
  createdAt?: Maybe<Scalars['ISODate']>;
  /** The date-time that the account was updated */
  updatedAt?: Maybe<Scalars['String']>;
  /** The number of times the user has logged in */
  loginsCount?: Maybe<Scalars['Int']>;
  /** Notifications for the user */
  notifications?: Maybe<Array<Maybe<any>>>;
};

export enum ActivityType {
  BOOKING = 'BOOKING',
  QUESTION = 'QUESTION',
  ACTIVITY_COMMENT = 'ACTIVITY_COMMENT',
  REVIEW = 'REVIEW',
  SAVED_EVENT = 'SAVED_EVENT',
  SAVED_EXTERNAL_BOOKING = 'SAVED_EXTERNAL_BOOKING',
  REVIEW_PHOTO = 'REVIEW_PHOTO',
  PHOTO = 'PHOTO',
}

export type ActivityReaction = {
  __typename?: 'ActivityReaction';
  /** The id for this activity reaction */
  id: Scalars['ID'];
  /** The likes for this action */
  likes?: Maybe<Array<Maybe<ActivityLike>>>;
  /** The comments for this action */
  comments?: Maybe<Array<Maybe<ActivityComment>>>;
};

export type ActivityLike = {
  __typename?: 'ActivityLike';
  /** The id of the activity like */
  id: Scalars['ID'];
  /** The user */
  user?: Maybe<User>;
  /** Whether the action is liked */
  isLiked?: Maybe<Scalars['Boolean']>;
  /** The date the action was first liked */
  createdAt?: Maybe<Scalars['ISODate']>;
  /** The date the action was last liked or unliked */
  updatedAt?: Maybe<Scalars['ISODate']>;
};

export type ActivityComment = {
  __typename?: 'ActivityComment';
  /** The id of the activity comment */
  id: Scalars['ID'];
  /** The text content of the comment */
  text?: Maybe<Scalars['String']>;
  /** The user */
  user?: Maybe<User>;
  /** Whether the comment is deleted */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** The date the action was first liked */
  createdAt?: Maybe<Scalars['ISODate']>;
  /** The date the action was last liked or unliked */
  updatedAt?: Maybe<Scalars['ISODate']>;
  /** The comments for this comment */
  reactions?: Maybe<ActivityReaction>;
};

export type Question = {
  __typename?: 'Question';
  /** The id for this question */
  id: Scalars['ID'];
  /** The user who asked this question */
  user?: Maybe<User>;
  /** The event this question is about */
  event?: Maybe<any>;
  /** The text content of the question */
  text?: Maybe<Scalars['String']>;
  /** The ID of the question when captured externally */
  externalId?: Maybe<Scalars['String']>;
  /** The date the question was asked */
  createdAt?: Maybe<Scalars['ISODate']>;
  /** The reactions to the question */
  reactions?: Maybe<ActivityReaction>;
};

export type SimpleNotificationAction = {
  __typename?: 'SimpleNotificationAction';
  type?: Maybe<NotificationActionType>;
  kind?: Maybe<NotificationActionKind>;
  message?: Maybe<Scalars['String']>;
  actor?: Maybe<User>;
  thumbnail?: Maybe<Thumbnail>;
  relativePermalink?: Maybe<Scalars['String']>;
  permalink?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export enum NotificationActionKind {
  APPROVED = 'APPROVED',
  LIKE = 'LIKE',
  COMMENT = 'COMMENT',
}

export enum NotificationStatus {
  UNSEEN = 'UNSEEN',
  SEEN = 'SEEN',
  READ = 'READ',
}

export type Thumbnail = {
  __typename?: 'Thumbnail';
  uri?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
};

export enum NotificationActionType {
  CONTENT_CHANGE_SUGGESTION_APPROVED = 'CONTENT_CHANGE_SUGGESTION_APPROVED',
  FINISHER_PHOTO_LIKE = 'FINISHER_PHOTO_LIKE',
  FINISHER_PHOTO_COMMENT = 'FINISHER_PHOTO_COMMENT',
  QUESTION_LIKE = 'QUESTION_LIKE',
  QUESTION_COMMENT = 'QUESTION_COMMENT',
  REPLY_LIKE = 'REPLY_LIKE',
  REPLY_COMMENT = 'REPLY_COMMENT',
}

export type ContentChangeSuggestionApprovedNotification = {
  __typename?: 'ContentChangeSuggestionApprovedNotification';
  type?: Maybe<NotificationActionType>;
  event?: Maybe<any>;
  contentChange?: Maybe<any>;
};

export type NotificationAction =
  | ContentChangeSuggestionApprovedNotification
  | SimpleNotificationAction;

export type Notification = {
  __typename?: 'Notification';
  id?: Maybe<Scalars['ID']>;
  entityId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  status?: Maybe<NotificationStatus>;
  action?: Maybe<NotificationAction>;
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  overall?: Maybe<Scalars['Float']>;
  course?: Maybe<Scalars['Float']>;
  organisation?: Maybe<Scalars['Float']>;
  atmosphere?: Maybe<Scalars['Float']>;
};

export type PhotoLike = {
  __typename?: 'PhotoLike';
  /** Primary Identity Id of the user who liked the photo */
  primaryIdentityId?: Maybe<Scalars['String']>;
  /** User object for a given like */
  user?: Maybe<User>;
};

export type ReviewImage = {
  __typename?: 'ReviewImage';
  comments?: Maybe<Array<Maybe<ActivityComment>>>;
  id?: Maybe<Scalars['ID']>;
  likes?: Maybe<Array<Maybe<PhotoLike>>>;
  uri?: Maybe<Scalars['String']>;
  /** The reactions to the review photo */
  reactions?: Maybe<ActivityReaction>;
};

export type Review = {
  __typename?: 'Review';
  /** The id of the review */
  id?: Maybe<Scalars['ID']>;
  /** The primary identity id of the user who created the review */
  primaryIdentityId?: Maybe<Scalars['ID']>;
  /** Review author */
  author?: Maybe<User>;
  /** The race */
  race?: Maybe<any>;
  /** The event */
  event?: Maybe<any>;
  /** The event */
  legacyEvent?: Maybe<any>;
  /** The year of the race */
  year?: Maybe<Scalars['Int']>;
  /** The text content of the review */
  review?: Maybe<Scalars['String']>;
  /** The review rating */
  ratings?: Maybe<ReviewRating>;
  /** The date-time that the account was created */
  createdAt?: Maybe<Scalars['String']>;
  /** The reactions to the review */
  reactions?: Maybe<ActivityReaction>;
  /** Third part origin source name */
  thirdPartyOrigin?: Maybe<Scalars['String']>;
  /** Third party response */
  thirdPartyResponse?: Maybe<Scalars['String']>;
  /** Tags (Reasons to recommend) */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Urls for the images submitted alongside the review */
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Urls and ids for the images submitted alongside the review */
  photos?: Maybe<Array<Maybe<ReviewImage>>>;
  /** Temporary token attached to guest reviews */
  token?: Maybe<Scalars['String']>;
};
